export const documentSearchDocumentationMarkdown = `
# Document Search

This block is under construction and is not ready for use!

Search through a collection of documents using semantic search and filtering.

## Configuration

- Search Query: Query to search documents with
- Metadata Filter: Optional filter for document metadata
- Text Filter: Optional filter for document text
- Top K: Number of results to return

## Output

Search results consisting of documents sorted by relevancy.

## Example

### Basic Document Search
Returning top 5 relevant documents for search query "diagnosis".

Search Query: "diagnosis",
Top K: 5


### With Filters
Returning top 3 relevant documents for search query "diagnosis", document metadata including "visit notes", and document text including "hypertension".

Search Query: "diagnosis",
Metadata Filter: "visit notes",
Text Filter: "hypertension",
Top K: 3

`;
